var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBusinessIcon = function SvgBusinessIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.554688 0.246094V30.8269H10.6027V24.8807H13.952V30.8269H24V0.246094H0.554688ZM3.90402 3.64397H7.25335V7.04184H3.90402V3.64397ZM10.6027 3.64397H13.952V7.04184H10.6027V3.64397ZM17.3013 3.64397H20.6507V7.04184H17.3013V3.64397ZM3.90402 10.4397H7.25335V13.8376H3.90402V10.4397ZM10.6027 10.4397H13.952V13.8376H10.6027V10.4397ZM17.3013 10.4397H20.6507V13.8376H17.3013V10.4397ZM3.90402 17.2355H7.25335V20.6333H3.90402V17.2355ZM10.6027 17.2355H13.952V20.6333H10.6027V17.2355ZM17.3013 17.2355H20.6507V20.6333H17.3013V17.2355ZM3.90402 24.0312H7.25335V27.4291H3.90402V24.0312ZM17.3013 24.0312H20.6507V27.4291H17.3013V24.0312Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/business-icon.c0cccc89d00214d33535d741d17a3df3.svg";